import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=31f8cf25&scoped=true&"
import script from "./InventoryForm.vue?vue&type=script&lang=js&"
export * from "./InventoryForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryForm.vue?vue&type=style&index=0&id=31f8cf25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8cf25",
  null
  
)

export default component.exports